import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row pt-5" }
const _hoisted_2 = { class: "text-2xl font-bold text-infoColor" }
const _hoisted_3 = { class: "justify-center pl-10" }
const _hoisted_4 = { class: "flex flex-col border-l-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_7 = { class: "px-5" }
const _hoisted_8 = {
  key: 0,
  class: "font-black"
}
const _hoisted_9 = {
  key: 1,
  class: "font-black text-red-600"
}
const _hoisted_10 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_11 = { class: "px-5" }
const _hoisted_12 = {
  key: 0,
  class: "font-black"
}
const _hoisted_13 = {
  key: 1,
  class: "font-black text-red-600"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_16 = { class: "px-5" }
const _hoisted_17 = { class: "text-warningColor" }
const _hoisted_18 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_19 = { class: "px-5" }
const _hoisted_20 = { class: "text-warningColor" }
const _hoisted_21 = { class: "flex flex-row pt-2 items-center text-lg text-infoColor" }
const _hoisted_22 = { class: "px-5" }
const _hoisted_23 = { class: "font-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.t('Result')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.event?.Status == _ctx.ParamEventStatus.Close)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('ConfirmDate')), 1),
                (_ctx.event?.IsResolution == _ctx.ParamIsResolution.Done)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.datetimeFormat(_ctx.event?.StartUTCDateTime ?? new Date().toISOString()) + _ctx.dayjs( _ctx.event?.EndUTCDateTime ?? new Date().toISOString()).format("HH:mm")), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.t('HostUndecide')), 1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('DecideLocation')), 1),
                (_ctx.event?.IsResolution == _ctx.ParamIsResolution.Done)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.event?.Location), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.t('HostUndecide')), 1))
              ])
            ]))
          : (_ctx.event?.Status == _ctx.ParamEventStatus.Cancel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t('ConfirmDate')), 1),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('MeeingCancel')), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.t('DecideLocation')), 1),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.t('MeeingCancel')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.t('Attendee')), 1),
          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.attendee?.map((a) => a.Name).join('；')), 1)
        ])
      ])
    ])
  ]))
}